export default __webpack_public_path__ + "static/media/section5_1.79bc00dc.png";